import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Beat } from "../../../plugins/spinners.plugin";
import Input from "../../inputs/inputs";
import Button from "../../buttons/buttons";
import Warning from "../../../assets/images/icons/warning.svg";
import { cleanInput } from "../../../helpers/cleanInput";
import { filterProductCategory } from "../../../redux/productCatergory/productCategoryAction";
import { filterSubscriptionFoodAction } from "../../../redux/subscriptionFood/subscriptionFoodActions";

export default function FilterPackageItemDropDown(props) {
  const { payLoad, isFilterOpen, setFilterState } = props;
  const dispatch = useDispatch();
  const { allCategories } = useSelector((state) => state.productCatergory);
  const { isLoading, filtering } = useSelector(
    (state) => state.subscriptionFood
  );

  const [errorMsg, setErrorMsg] = useState(false);
  const [data, setData] = useState({
    food_name: "",
    food_amount: "",
    food_categories: [],
    start_date: "",
    end_date: "",
  });
  const { food_name, food_amount, food_categories, start_date, end_date } =
    data;

  useEffect(() => {
    dispatch(filterProductCategory({ type: "restaurant" }, 1));
    // eslint-disable-next-line
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "food_categories") {
      setData({ ...data, food_categories: [value] });
    } else {
      setData({ ...data, [name]: value });
    }
  };

  const handleReset = async () => {
    setData({
      food_name: "",
      food_amount: "",
      food_categories: [],
      start_date: "",
      end_date: "",
    });
    await dispatch(filterSubscriptionFoodAction(payLoad, 1));
    setFilterState(!isFilterOpen);
  };

  const handleSubmit = async () => {
    cleanInput(data);
    if (
      food_name ||
      food_amount ||
      food_categories.length > 0 ||
      start_date ||
      end_date
    ) {
      setErrorMsg(false);
      try {
        const response = await dispatch(
          filterSubscriptionFoodAction({
            ...data,
          })
        );
        if (response?.status === "success") {
          setFilterState(!isFilterOpen);
        }
      } catch (error) {
        console.log(error);
        setFilterState(!isFilterOpen);
      }
    } else {
      setErrorMsg(true);
    }
  };

  return (
    <div data-test="">
      <form className="py-5 mt-4 px-5">
        <div className="grid grid-cols-1">
          <Input.Label
            title={"Food Name"}
            type="text"
            name="food_name"
            id="food_name"
            value={food_name}
            autoComplete="off"
            className="w-full border border-[#E4E4F3] focus:border-primary focus:ring-0 sm:text-sm"
            placeholder="Enter food name"
            onChange={handleChange}
          />

          <Input.Select
            title={"Food Category"}
            name="food_categories"
            id="food_categories"
            autoComplete="off"
            htmlFor={"food_categories"}
            defaultValue={food_categories?.[0]}
            className="w-full border border-[#E4E4F3] focus:border-primary focus:ring-0 sm:text-sm"
            placeholder="E.g: 200"
            onChange={handleChange}
          >
            <option>Select Category</option>
            {allCategories?.data?.length > 0 &&
              allCategories?.data?.map(
                (category, i) =>
                  category.type === "restaurant" && (
                    <option key={i} value={category?.name}>
                      {category?.name}
                    </option>
                  )
              )}
          </Input.Select>

          <Input.Number
            title="Food Amount"
            className="w-full border border-[#E4E4F3] focus:border-primary focus:ring-0 sm:text-sm"
            placeholder="Enter package amount"
            name="food_amount"
            id="food_amount"
            defaultValue={food_amount}
            htmlFor="food_amount"
            onChange={handleChange}
          />

          <Input.DatePicker
            title={"Start Date"}
            name="start_date"
            id="start_date"
            htmlFor={"start_date"}
            defaultValue={start_date}
            className="w-full border border-[#E4E4F3] focus:border-primary focus:ring-0 sm:text-sm"
            onChange={handleChange}
            selected
          />
          <Input.DatePicker
            title={"End Date"}
            name="end_date"
            id="end_date"
            htmlFor={"end_date"}
            defaultValue={end_date}
            className="w-full border border-[#E4E4F3] focus:border-primary focus:ring-0 sm:text-sm"
            onChange={handleChange}
            selected
          />
        </div>
        <div className="py-8 grid grid-cols-2 gap-6 text-center">
          <Button.Secondary
            disabled={isLoading}
            title={isLoading ? <Beat color={"#ce2600"} /> : "Reset"}
            className="px-4"
            onClick={handleReset}
            type="button"
          />
          <Button.Primary
            disabled={filtering}
            title={filtering ? <Beat color={"#ffffff"} /> : "Filter"}
            className="px-4"
            onClick={handleSubmit}
            type="button"
          />
        </div>
        {errorMsg && (
          <div className="flex gap-1 -mt-2">
            <img src={Warning} alt="warning" />
            <p>No value to filter by</p>
          </div>
        )}
      </form>
    </div>
  );
}
